<div class="logo-container">
	<img class="img" src="/assets/img/logo-adobesign.jpg" />
	<img class="text" src="/assets/img/logo-adobesign-text.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- STEP 1 -->
<div [ngClass]="{'hidden': loading || step !== 1}">
	<div class="button-container" *ngIf="!loading">
		<button (click)="selectExistingAdobeSign()">I have an Adobe Sign Account</button>
		<button (click)="selectNewAdobeSign()">I need an Adobe Sign Account</button>
	</div>
</div>

<!-- STEP 2 -->
<div [ngClass]="{'hidden': loading || step !== 2}">
	<div [ngClass]="{'hidden': !existingAdobeSign}">
		<div class="text-container">To continue, create a new app in Adobe Sign and enter the following information.</div>
		<form #h="ngForm" [formGroup]="formAPIKeys">
			<div class="form-container">
				<label>Application ID</label>
				<input #inputId formControlName="id" [ngClass]="{'valid': idValid == true, 'invalid': idValid == false}" (change)="doIdValidation($event)" />
				<label>Application Client Secret</label>
				<input #inputSecret formControlName="secret" [ngClass]="{'valid': secretValid == true, 'invalid': secretValid == false}" (change)="doSecretValidation($event)" />
			</div>
			<div class="button-container" *ngIf="!loading">
				<button class="disabled" *ngIf="!idValid || !secretValid">Continue</button>
				<button *ngIf="idValid && secretValid" (click)="updateAPIKeys()">Continue</button>
				<button class="secondary" (click)="selectBack()">Back</button>
			</div>
		</form>
	</div>
	<div [ngClass]="{'hidden': existingAdobeSign}">
		<div class="text-container">
			<p>Please contact <a href="mailto:support@shakeit.ai" target="_blank">support&#64;shakeit.ai</a> to perform a trial or purchase a Adobe Sign subscription.</p>
			<p><b>Trial</b><br />You will be provided with a 5 request license that can be used for testing. You will have access to a limited-use Adobe Sign account during the trial.</p>
			<p><b>Purchase</b><br />You will be provided with quotes for standard and premium subscriptions based on your estimated usage per annum. Both shared and dedicated plans are available.</p>
		</div>
		<div class="button-container">
			<button class="secondary" (click)="selectBack()">Back</button>
		</div>
	</div>
</div>